import {Component, Input, OnInit, Output} from '@angular/core';
import {Option} from '../../classes/option';
import {StorageService} from '../../services/storage.service';

/**
 * Created by strunz on 12.05.2017.
 */


@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent implements OnInit {
    @Input() option: Option;
    @Output() value = false;

    constructor(private storageService: StorageService) {
    }

    ngOnInit(): void {
        if (this.option.getAllItems()[1].active) {
            this.value = true;
        } else {
            this.value = false;
        }
    }

    update(): void {
        this.value = !this.value;
        if (this.value) {
            this.option.getAllItems()[0].active = false;
            this.option.getAllItems()[1].active = true;
        } else {
            this.option.getAllItems()[0].active = true;
            this.option.getAllItems()[1].active = false;
        }
        console.log(this.storageService.products);
        this.storageService.updateOptions();
        console.log(this.value);
    }

}